// extracted by mini-css-extract-plugin
export var background = "_60-0";
export var container = "_60-1";
export var contentItem = "_60-7";
export var extendedWarranty = "_60-5";
export var link = "_60-d";
export var modal = "_60-b";
export var modalCloseButton = "_60-9";
export var modalContent = "_60-3";
export var modalContentMain = "_60-6";
export var modalImageLogo = "_60-8";
export var modalLogo = "_60-a";
export var modalSideImage = "_60-4";
export var preview = "_60-c";
export var redoModal = "_60-2";